import { ISignInState, initialSignInState } from 'src/app/store/state/auth.signin.state';
import * as SystemActions from 'src/app/store/system/actions/system.actions';
import * as AuthActions from 'src/app/store/auth/actions/auth.actions';
import { UserScope } from 'src/app/models/auth';
import { IAppState, initialAppState } from '../../state/app.state';

export const validTypes: UserScope[] = ['Portfolio Administration', 'Investment Management Viewer'];

export function SignInReducer(state = initialSignInState, action: AuthActions.AuthActions | SystemActions.SystemActions): ISignInState {
    switch (action.type) {
        case AuthActions.AUTHENTICATE_TFA_INIT:
            return {
                ...state,
                requireTFA: true,
                loading: false,
                authFailText: '',
            };
        case AuthActions.AUTHENTICATE:
            return {
                ...state,
                authFailText: '',
                requireTFA: false,
                loading: true
            };
        case AuthActions.AUTHENTICATE_TFA:
            return {
                ...state,
                authFailText: '',
                loading: true
            };
        case AuthActions.ASSUME_USER:
            return {
                ...state,
                loading: true
            };
        case AuthActions.AUTHENTICATE_SUCCESS:
        case AuthActions.AUTHENTICATE_TFA_SUCCESS:
        case AuthActions.ASSUME_USER_SUCCESS:
            return {
                ...state,
                requireTFA: false,
                loading: false,
                authFailText: '',
                hasFalseInception: action.payload.hasFalseInception
            };
        case AuthActions.AUTHENTICATE_FAIL:
        case AuthActions.AUTHENTICATE_TFA_FAIL:
        case AuthActions.ASSUME_USER_FAIL:
            return {
                ...state,
                loading: false,
                authFailText: action.payload
            };
        case AuthActions.GET_IDENTITY_USERS:
            return {
                ...state,
                loading: true
            };
        case AuthActions.SET_IDENTITY_USERS:
            return {
                ...state,
                loading: false,
                identityUsers: action.payload
            };
        case AuthActions.GET_IDENTITY_USERS_FAIL:
            return {
                ...state,
                loading: false
            };
        case SystemActions.CLEAR_SYSTEM:
            return initialSignInState;
        default:
            return state;
    }
}

export function SignOutReducer(state = initialAppState, action: AuthActions.AuthActions | SystemActions.SystemActions): IAppState {
    switch (action.type) {
        case AuthActions.LOGOUT_SUCCESS:
        case SystemActions.CLEAR_SYSTEM:
            return initialAppState;
        default:
            return state;
    }
}